import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import InputAdornment from "@mui/material/InputAdornment";
import Iphone from "../../assets/colors.png";
import { Home, Settings } from "tabler-icons-react";
import { useAlert } from "react-alert";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { timezones } from "../../utils/Timezones";
import { useNavigate } from "react-router-dom";
import { InfoCircle, Eye, EyeOff } from "tabler-icons-react";
import Step1 from "../../assets/step1.png";
import Step2 from "../../assets/step2.png";
import Step3 from "../../assets/step3.png";
import Step10 from "../../assets/step10.png";
import Step11 from "../../assets/step11.png";
import WCStep1 from "../../assets/wcstep1.png";
import WCStep2 from "../../assets/wcstep2.png";
import WCStep3 from "../../assets/wcstep3.png";
import {
	CircularProgress,
	Divider,
	Modal,
	Step,
	StepContent,
	StepLabel,
	Stepper,
	IconButton,
} from "@mui/material";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import WelcomeImage from "../../assets/onboarding.png";
import OnboardingFinishedImage from "../../assets/onboarding-2.png";
import imageCompression from "browser-image-compression";
import Tooltip from "@mui/material/Tooltip";
import { CreatorContext } from "../../context/CreatorContext";

const useStyles = makeStyles({
	alert: {
		cursor: "pointer",
		"& *": {
			cursor: "pointer",
		},
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	},
	pickerContainer: {
		"& #font-picker": {
			width: "100%!important",
			background: "none!important",
			backgroundColor: "none!important",
			boxShadow: "none!important",
			border: "1px solid #D0D0D0",
			borderRadius: 4,
			padding: 4,
		},

		"& #font-picker button": {
			background: "none!important",
		},
		"& #font-picker ul": {
			background: "fafafa!important",
			boxShadow: "none!important",
		},
	},
	logo: {
		height: "100%",
		objectFit: "contain",
		maxWidth: 100,
		margin: "12px 0px",
	},
	formControl: {
		"& hover": {
			backgroundColor: "#434343",
		},
	},
});

const languageOptions = [
	{ id: "en", name: "English" },
	{ id: "es", name: "Español" },
];
const timezoneOptions = timezones.map((timezone) => ({
	id: timezone,
	name: timezone,
}));
const currencyOptions = [
	{ id: "usd", name: "USD Dollar" },
	{ id: "eur", name: "Euro" },
	{ id: "gbp", name: "British Pound Sterling" },
	{ id: "jpy", name: "Japanese Yen" },
	{ id: "aud", name: "Australian Dollar" },
	{ id: "chf", name: "Swiss Franc" },
	{ id: "cny", name: "Chinese Renminbi" },
	{ id: "nzd", name: "New Zealand Dollar" },
];

export default function General({
	drawerWidth,
	setRun,
	setOnboardingStarted,
	onboardingFinished,
	setOnboardingFinished,
}) {
	const [loading, setLoading] = useState(false);
	const [generalData, setGeneralData] = useState(null);
	const [platformSettings, setPlatformSettings] = useState("");
	const [stripeKey, setStripeKey] = useState("");
	const [stripePublicKey, setStripePublicKey] = useState("");
	const [stripeWebhook, setStripeWebhook] = useState("");
	const [showStripe, setShowStripe] = useState(false);
	const [showStripePublic, setShowStripePublic] = useState(false);
	const [showStripeWebhook, setShowStripeWebhook] = useState(false);
	const [showStripeModal, setShowStripeModal] = useState(false);
	const [showStripePublicModal, setShowStripePublicModal] = useState(false);
	const [showStripeWebhookModal, setShowStripeWebhookModal] = useState(false);
	const [woocommerceURL, setWoocommerceURL] = useState("");
	const [woocommerceConsumerKey, setWoocommerceConsumerKey] = useState("");
	const [woocommerceConsumerSecret, setWoocommerceConsumerSecret] =
		useState("");
	const [showWoocommerceKey, setShowWoocommerceKey] = useState(false);
	const [showWoocommerceSecret, setShowWoocommerceSecret] = useState(false);
	const [showWoocommerceURLModal, setShowWoocommerceURLModal] = useState(false);
	const { user, getUser } = useContext(UserContext);
	const [showWelcomeModal, setShowWelcomeModal] = useState(
		!user?.subscription?.isOnlyWeb &&
			!user?.finishOnboarding &&
			document.body.clientWidth > 767
	);
	const [showWelcomeModalMobile, setShowWelcomeModalMobile] = useState(
		!user?.subscription?.isOnlyWeb &&
			!user?.finishOnboarding &&
			document.body.clientWidth <= 767
	);
	const [imagesLoading, setImagesLoading] = useState({});
	const classes = useStyles();
	const alert = useAlert();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { getCreator } = useContext(CreatorContext);

	const formatFontFamily = (font) => {
		let newFont = [];
		let index = 0;
		for (const char of font.split("")) {
			if (
				char >= "A" &&
				char <= "Z" &&
				index > 0 &&
				!(font[index - 1] >= "A" && font[index - 1] <= "Z")
			) {
				newFont.push(" " + char);
			} else {
				newFont.push(char);
			}
			index += 1;
		}
		return newFont.join("");
	};

	const saveGeneralData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					...generalData,
					fontFamily: generalData.fontFamily.split(" ").join(""),
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			await axios.post(
				ADMIN_URL + "metadata",
				{
					privacyURL: generalData.privacyURL,
					termsURL: generalData.termsURL,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			await axios.put(
				ADMIN_URL + "platformSettings/" + platformSettings.id,
				{
					stripeKey: stripeKey,
					stripePublicKey: stripePublicKey,
					stripeWebhook: stripeWebhook,
					backendURL: woocommerceURL === "AL" ? "" : woocommerceURL,
					backendKey:
						woocommerceConsumerKey === "AL" ? "" : woocommerceConsumerKey,
					backendSecret:
						woocommerceConsumerSecret === "AL" ? "" : woocommerceConsumerSecret,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			getUser();
			getCreator();
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [
		alert,
		generalData,
		platformSettings.id,
		stripeKey,
		stripePublicKey,
		stripeWebhook,
		t,
		woocommerceURL,
		woocommerceConsumerKey,
		woocommerceConsumerSecret,
	]);

	useEffect(() => {
		const getMetadata = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "metadata", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setGeneralData((prev) => ({
					...prev,
					...{
						privacyURL: res.data.metadata.privacyURL,
						termsURL: res.data.metadata.termsURL,
					},
				}));
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};
		const getGeneralData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creators", {
					headers: { authorization: localStorage.getItem("token") },
				});
				if (res.data.backendURL) {
					setWoocommerceURL(
						res.data.backendURL === "AL" ? "" : res.data.backendURL
					);
				}
				if (res.data.backendKey) {
					setWoocommerceConsumerKey(
						res.data.backendKey === "AL" ? "" : res.data.backendKey
					);
				}
				if (res.data.backendSecret) {
					setWoocommerceConsumerSecret(
						res.data.backendSecret === "AL" ? "" : res.data.backendSecret
					);
				}
				setGeneralData({
					...res.data,
					fontFamily: formatFontFamily(res.data.fontFamily),
				});
				getMetadata();
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};
		const getStripeKey = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "platformSettings", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setPlatformSettings(res.data[0]);
				setStripeKey(res.data[0].stripeKey);
				setStripePublicKey(res.data[0].stripePublicKey);
				setStripeWebhook(res.data[0].stripeWebhook);
				if (res.data[0].backendURL) {
					setWoocommerceURL(res.data[0].backendURL);
				}
				if (res.data[0].backendKey) {
					setWoocommerceConsumerKey(res.data[0].backendKey);
				}
				if (res.data[0].backendSecret) {
					setWoocommerceConsumerSecret(res.data[0].backendSecret);
				}
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};
		getGeneralData();
		getStripeKey();
	}, []);

	const openFile = async (file, key, options, generalData, imagesLoading) => {
		setImagesLoading({ ...imagesLoading, [key]: true });

		let compressedFile = await imageCompression(file.target.files[0], {
			maxSizeMB: 1,
			alwaysKeepResolution: options?.width || options?.height,
		});

		const reader = new FileReader();
		reader.onload = function () {
			const saveFile = async (dataURL) => {
				setGeneralData({
					...generalData,
					[key]: dataURL,
				});
			};
			const dataURL = reader.result;
			if (options) {
				const image = new Image();
				image.src = dataURL;
				image.onload = function () {
					const height = this.height;
					const width = this.width;
					if (options.height !== height || options.width > width) {
						alert.show(options.message, { type: "error" });
					} else {
						saveFile(dataURL);
					}
				};
			} else {
				saveFile(dataURL);
			}
			setImagesLoading({ ...imagesLoading, [key]: false });
		};
		reader.readAsDataURL(compressedFile);
	};

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
				}}
			>
				<Toolbar />
				{!user?.subscription?.isOnlyWeb && (
					<Alert
						severity="info"
						sx={{
							marginBottom: 2,
						}}
						className={classes.alert}
						onClick={() => {
							navigate("/qr");
						}}
					>
						{t("general.qr")}
					</Alert>
				)}
				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									minHeight: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								{user?.subscription?.isOnlyWeb
									? t("general.mainTitleWeb")
									: t("general.mainTitle")}
							</Typography>
							{generalData && (
								<>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{user?.subscription?.isOnlyWeb
												? t("general.appNameWeb")
												: t("general.appName")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.appName}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													appName: e.target.value,
												});
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									{!user?.subscription?.isOnlyWeb && (
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.appDescription")}
											</InputLabel>
											<TextField
												id="app-description-input"
												fullWidth
												InputProps={{
													readOnly: ["building"].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													),
												}}
												variant="outlined"
												value={generalData.appDescription}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														appDescription: e.target.value,
													});
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										</FormControl>
									)}
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
									>
										<InputLabel
											shrink
											htmlFor="app-description-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{user?.subscription?.isOnlyWeb
												? t("general.appLogoWeb")
												: t("general.appLogo")}
										</InputLabel>

										<TextField
											id="app-description-input"
											fullWidth
											variant="outlined"
											InputProps={{
												readOnly: true,
												startAdornment: (
													<InputAdornment position="start">
														<Box>
															<Button
																size="small"
																variant="contained"
																component="label"
																color="primary"
																disabled={[
																	"building",
																	"built",

																	"publishing",
																	"published",
																	"inviting",
																].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)}
																sx={{
																	height: "24px",
																	fontSize: "10px",
																}}
															>
																{imagesLoading.appLogo ? (
																	<CircularProgress
																		sx={{ color: "white!important" }}
																		size={12}
																	/>
																) : (
																	t("general.upload")
																)}

																<input
																	type="file"
																	accept="image/png, image/jpeg"
																	hidden
																	onChange={(e) => {
																		openFile(
																			e,
																			"appLogo",
																			null,
																			generalData,
																			imagesLoading
																		);
																	}}
																/>
															</Button>
														</Box>
													</InputAdornment>
												),
												endAdornment: generalData.appLogo && (
													<Box sx={{ position: "relative" }}>
														<img
															className={classes.logo}
															src={generalData.appLogo}
															alt="logo"
														/>
														<IconButton
															color="inherit"
															aria-label="delete image"
															edge="start"
															onClick={() => {
																setGeneralData({
																	...generalData,
																	appLogo: null,
																});
															}}
															sx={{
																position: "absolute",
																background: "#43BD98",
																top: 0,
																right: "-15px",
																width: "24px",
																height: "24px",
																"&:hover": {
																	background: "#43BD98!important",
																},
															}}
														>
															<Close
																sx={{ color: "#ffffff" }}
																style={{ width: 12, height: 12 }}
															/>
														</IconButton>
													</Box>
												),
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										></TextField>
									</FormControl>
									{!user?.subscription?.isOnlyWeb && (
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.appIconLogoFor")}{" "}
												<a
													href="https://developer.apple.com/design/human-interface-guidelines/foundations/app-icons/"
													target="_blank"
													style={{ fontWeight: "bold" }}
													rel="noreferrer"
												>
													iOS
												</a>{" "}
												{t("general.i")}{" "}
												<a
													href="https://developer.android.com/distribute/google-play/resources/icon-design-specifications"
													target="_blank"
													style={{ fontWeight: "bold" }}
													rel="noreferrer"
												>
													Android
												</a>{" "}
												<span style={{ textTransform: "lowercase" }}>
													(1024x1024px)*
												</span>
											</InputLabel>

											<TextField
												id="app-description-input"
												fullWidth
												variant="outlined"
												readonly
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="start">
															<Box>
																<Button
																	size="small"
																	variant="contained"
																	component="label"
																	color="primary"
																	disabled={[
																		"building",
																		"built",

																		"publishing",
																		"published",
																		"inviting",
																	].find(
																		(status) =>
																			status ===
																			(user.app.appStatuses.length === 0
																				? ""
																				: user.app.appStatuses.length > 0 &&
																				  user.app.appStatuses[0].status)
																	)}
																	sx={{
																		height: "24px",
																		fontSize: "10px",
																	}}
																>
																	{imagesLoading.appIconLogo ? (
																		<CircularProgress
																			sx={{ color: "white!important" }}
																			size={12}
																		/>
																	) : (
																		t("general.upload")
																	)}
																	<input
																		type="file"
																		accept="image/png, image/jpeg"
																		hidden
																		onChange={(e) => {
																			openFile(
																				e,
																				"appIconLogo",
																				{
																					width: 1024,
																					height: 1024,
																					message: t("general.invalidSize"),
																				},
																				generalData,
																				imagesLoading
																			);
																		}}
																	/>
																</Button>
															</Box>
														</InputAdornment>
													),
													endAdornment: generalData.appIconLogo && (
														<Box sx={{ position: "relative" }}>
															<img
																className={classes.logo}
																src={generalData.appIconLogo}
																alt="logo"
															/>
															<IconButton
																color="inherit"
																aria-label="delete image"
																edge="start"
																onClick={() => {
																	setGeneralData({
																		...generalData,
																		appIconLogo: null,
																	});
																}}
																sx={{
																	position: "absolute",
																	background: "#43BD98",
																	top: 0,
																	right: "-15px",
																	width: "24px",
																	height: "24px",
																	"&:hover": {
																		background: "#43BD98!important",
																	},
																}}
															>
																<Close
																	sx={{ color: "#ffffff" }}
																	style={{ width: 12, height: 12 }}
																/>
															</IconButton>
														</Box>
													),
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											></TextField>
										</FormControl>
									)}
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-language-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("general.language")}
										</InputLabel>
										<TextField
											select
											id="app-language-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.language}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													language: e.target.value,
												});
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										>
											{languageOptions.map((option) => (
												<MenuItem value={option.id}>{option.name}</MenuItem>
											))}
										</TextField>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-timezone-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("general.timezone")}
										</InputLabel>
										<TextField
											select
											id="app-timezone-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.timezone}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													timezone: e.target.value,
												});
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										>
											{timezoneOptions.map((option) => (
												<MenuItem value={option.id}>{option.name}</MenuItem>
											))}
										</TextField>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-currency-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("general.currency")}
											{user.app.appType === "Woocommerce" && (
												<Tooltip title={t("general.currencyTooltip")}>
													<span>
														<InfoCircle
															style={{ marginLeft: 5, cursor: "pointer" }}
															size={16}
														/>
													</span>
												</Tooltip>
											)}
										</InputLabel>
										<TextField
											select
											id="app-currency-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.currency}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													currency: e.target.value,
												});
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										>
											{currencyOptions.map((option) => (
												<MenuItem value={option.id}>{option.name}</MenuItem>
											))}
										</TextField>
									</FormControl>
									{!user?.subscription?.isOnlyWeb && (
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
											className={classes.formControl}
										>
											<InputLabel
												shrink
												htmlFor="app-name-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("metadata.privacyURL")}
											</InputLabel>
											<TextField
												id="app-name-input"
												fullWidth
												InputProps={{
													readOnly: ["building"].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													),
												}}
												variant="outlined"
												value={generalData.privacyURL}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														privacyURL: e.target.value,
													});
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										</FormControl>
									)}
									{!user?.subscription?.isOnlyWeb && (
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
											className={classes.formControl}
										>
											<InputLabel
												shrink
												htmlFor="app-name-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("metadata.termsURL")}
											</InputLabel>
											<TextField
												id="app-name-input"
												fullWidth
												InputProps={{
													readOnly: ["building"].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													),
												}}
												variant="outlined"
												value={generalData.termsURL}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														termsURL: e.target.value,
													});
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										</FormControl>
									)}
								</>
							)}
							{(user.app.appType !== "Services" ||
								(user.app.appType === "Services" &&
									generalData?.enableVouchers)) && (
								<>
									<Divider sx={{ marginBottom: 4, marginTop: 2 }} />
									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom:
												generalData?.enableVouchers &&
												user.app.appType === "Services"
													? 0
													: 4,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("cart.stripeConfiguration1")}{" "}
										<small>
											{generalData?.enableVouchers &&
											user.app.appType === "Services"
												? t("cart.stripeConfiguration2Services")
												: t("cart.stripeConfiguration2")}
										</small>
									</Typography>
									{generalData?.enableVouchers &&
										user.app.appType === "Services" && (
											<Typography
												sx={{
													fontSize: 12,
													marginTop: 2,
													marginBottom: 4,
													fontWeight: 700,
												}}
												color="text.secondary"
												gutterBottom
											>
												{t("cart.stripeConfiguration2ServicesInfo")}
											</Typography>
										)}
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
									>
										<InputLabel
											shrink
											htmlFor="stripe-key-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
												display: "flex",
												alignItems: "center",
											}}
										>
											{t("cart.stripeRestrictedSecretKey")}{" "}
											<InfoCircle
												style={{ marginLeft: 5, cursor: "pointer" }}
												size={16}
												onClick={() => {
													setShowStripeModal(true);
												}}
											/>
										</InputLabel>
										<TextField
											id="stripe-key-input"
											fullWidth
											variant="outlined"
											value={stripeKey}
											onChange={(e) => {
												setStripeKey(e.target.value);
											}}
											disabled={[
												"building",
												"built",
												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
											type={showStripe ? "text" : "password"}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() => {
																setShowStripe(!showStripe);
															}}
															onMouseDown={(event) => {
																event.preventDefault();
															}}
															edge="end"
														>
															{showStripe ? <VisibilityOff /> : <Visibility />}
														</IconButton>
													</InputAdornment>
												),
												autocomplete: "new-password",
											}}
											autoComplete="new-password"
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
									>
										<InputLabel
											shrink
											htmlFor="stripe-public-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
												display: "flex",
												alignItems: "center",
											}}
										>
											{t("cart.stripePublicKey")}{" "}
											<InfoCircle
												style={{ marginLeft: 5, cursor: "pointer" }}
												size={16}
												onClick={() => {
													setShowStripePublicModal(true);
												}}
											/>
										</InputLabel>
										<TextField
											id="stripe-public-input"
											fullWidth
											variant="outlined"
											value={stripePublicKey}
											onChange={(e) => {
												setStripePublicKey(e.target.value);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
											type={showStripePublic ? "text" : "password"}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() => {
																setShowStripePublic(!showStripePublic);
															}}
															onMouseDown={(event) => {
																event.preventDefault();
															}}
															edge="end"
														>
															{showStripePublic ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
												autocomplete: "new-password",
											}}
											autoComplete="new-password"
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
									>
										<InputLabel
											shrink
											htmlFor="stripe-webhook-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
												display: "flex",
												alignItems: "center",
											}}
										>
											{t("cart.stripeWebhookSecret")}{" "}
											<InfoCircle
												style={{ marginLeft: 5, cursor: "pointer" }}
												size={16}
												onClick={() => {
													setShowStripeWebhookModal(true);
												}}
											/>
										</InputLabel>
										<TextField
											id="stripe-webhook-input"
											fullWidth
											variant="outlined"
											value={stripeWebhook}
											onChange={(e) => {
												setStripeWebhook(e.target.value);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
											type={showStripeWebhook ? "text" : "password"}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() => {
																setShowStripeWebhook(!showStripeWebhook);
															}}
															onMouseDown={(event) => {
																event.preventDefault();
															}}
															edge="end"
														>
															{showStripeWebhook ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
												autocomplete: "new-password",
											}}
											autoComplete="new-password"
										/>
									</FormControl>
									<Alert
										severity="info"
										sx={{
											marginBottom: 2,
										}}
									>
										<b style={{ display: "block", width: "100%" }}>
											{t("stripe.stripeDisclaimerTitle")}
										</b>

										{t("stripe.stripeDisclaimer")}
										<br />
										{t("stripe.stripeDisclaimer2")}
									</Alert>
									{user.app.appType === "Woocommerce" && (
										<>
											<Divider sx={{ marginBottom: 4, marginTop: 2 }} />
											<Typography
												sx={{
													fontSize: 12,
													marginTop: 2,
													marginBottom: 4,
													fontWeight: 700,
													textTransform: "uppercase",
												}}
												color="text.secondary"
												gutterBottom
											>
												{t("woocommerce.woocommerceConfiguration1")}{" "}
												<small>
													{t("woocommerce.woocommerceConfiguration2")}
												</small>
											</Typography>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="woocomerce-url-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
														display: "flex",
														alignItems: "center",
													}}
												>
													{t("woocommerce.woocommerceURL")}
												</InputLabel>
												<TextField
													id="woocommerce-url-input"
													fullWidth
													variant="outlined"
													value={woocommerceURL}
													onChange={(e) => {
														setWoocommerceURL(e.target.value);
													}}
													disabled={[
														"building",
														"built",
														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="woocomerce-consumer-key"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
														display: "flex",
														alignItems: "center",
													}}
												>
													{t("woocommerce.woocommerceCK")}
													<InfoCircle
														style={{ marginLeft: 5, cursor: "pointer" }}
														size={16}
														onClick={() => {
															setShowWoocommerceURLModal(true);
														}}
													/>
												</InputLabel>
												<TextField
													id="woocommerce-consumer-key"
													fullWidth
													variant="outlined"
													value={woocommerceConsumerKey}
													onChange={(e) => {
														setWoocommerceConsumerKey(e.target.value);
													}}
													type={showWoocommerceKey ? "text" : "password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton
																	aria-label="toggle password visibility"
																	onClick={() => {
																		setShowWoocommerceKey(!showWoocommerceKey);
																	}}
																	onMouseDown={(event) => {
																		event.preventDefault();
																	}}
																	edge="end"
																>
																	{showWoocommerceKey ? (
																		<VisibilityOff />
																	) : (
																		<Visibility />
																	)}
																</IconButton>
															</InputAdornment>
														),
														autocomplete: "new-password",
													}}
													autoComplete="new-password"
													disabled={[
														"building",
														"built",
														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="woocomerce-url-consumer-secret"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
														display: "flex",
														alignItems: "center",
													}}
												>
													{t("woocommerce.woocommerceCS")}
													<InfoCircle
														style={{ marginLeft: 5, cursor: "pointer" }}
														size={16}
														onClick={() => {
															setShowWoocommerceURLModal(true);
														}}
													/>
												</InputLabel>
												<TextField
													id="woocommerce-consumer-secret"
													fullWidth
													variant="outlined"
													value={woocommerceConsumerSecret}
													onChange={(e) => {
														setWoocommerceConsumerSecret(e.target.value);
													}}
													type={showWoocommerceSecret ? "text" : "password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton
																	aria-label="toggle password visibility"
																	onClick={() => {
																		setShowWoocommerceSecret(
																			!showWoocommerceSecret
																		);
																	}}
																	onMouseDown={(event) => {
																		event.preventDefault();
																	}}
																	edge="end"
																>
																	{showWoocommerceSecret ? (
																		<VisibilityOff />
																	) : (
																		<Visibility />
																	)}
																</IconButton>
															</InputAdornment>
														),
														autocomplete: "new-password",
													}}
													autoComplete="new-password"
													disabled={[
														"building",
														"built",
														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
										</>
									)}
								</>
							)}
						</CardContent>
						{!["inviting", "building", "built", "publishing", "published"].find(
							(status) =>
								status ===
								(user.app.appStatuses.length === 0
									? ""
									: user.app.appStatuses.length > 0 &&
									  user.app.appStatuses[0].status)
						) && (
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={saveGeneralData}
									disabled={loading}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						)}
					</>
				</Card>
			</Box>
			<div>
				<Modal
					open={showStripeModal}
					onClose={() => {
						setShowStripeModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: "calc(100% - 40px)",
							maxWidth: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("stripe.stripeConfiguration")}
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={-1} active={true}>
								<StepLabel>
									<b>{t("stripe.step0")}</b>
								</StepLabel>
							</Step>
							<Step key={0} active={true}>
								<StepLabel>
									{t("stripe.step1")}{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									{t("stripe.step2")}
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									{t("stripe.step3")}{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step4")}
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									{t("stripe.step5")}{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step6")}
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>
									{t("stripe.step7") + " "}
									<a
										href="https://applaby.com"
										target="_blank"
										rel="noreferrer"
									>
										https://applaby.com
									</a>
									{" " + t("stripe.step7Bis")}
								</StepLabel>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>{t("stripe.step8")}</StepLabel>
								<StepContent>
									<ul style={{ fontSize: "12px" }}>
										{t("stripe.step8Bis")
											.split(",")
											.map((s) => (
												<li>{s}</li>
											))}
									</ul>
									<img style={{ maxWidth: "100%" }} src={Step2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={5} active={true}>
								<StepLabel>{t("stripe.step9")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step3} alt="step3" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
				<Modal
					open={showWoocommerceURLModal}
					onClose={() => {
						setShowWoocommerceURLModal(false);
					}}
				>
					<div
						style={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: "calc(100% - 40px)",
							maxWidth: 800,
							backgroundColor: "white",
							boxShadow: 24,
							padding: 20,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
							background: "white",
							borderRadius: 4,
						}}
					>
						<h6>{t("woocommerce.woocommerceTitle")}</h6>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={0} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep1")}</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep2")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={WCStep1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep3")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={WCStep2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep4")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={WCStep3} alt="step3" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep5")}</StepLabel>
							</Step>
							<Step key={5} active={true}>
								<StepLabel>{t("woocommerce.woocommerceStep6")}</StepLabel>
							</Step>
						</Stepper>
					</div>
				</Modal>
				<Modal
					open={showStripePublicModal}
					onClose={() => {
						setShowStripePublicModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							Stripe configuration
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={-1} active={true}>
								<StepLabel>
									<b>{t("stripe.step0")}</b>
								</StepLabel>
							</Step>
							<Step key={0} active={true}>
								<StepLabel>
									{t("stripe.step1")}{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									{t("stripe.step2")}
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									{t("stripe.step3")}{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step4")}
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									{t("stripe.step5")}{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step6")}
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>
									{t("stripe.step7") + " "}
									<a
										href="https://applaby.com"
										target="_blank"
										rel="noreferrer"
									>
										https://applaby.com
									</a>
									{" " + t("stripe.step7Bis")}
								</StepLabel>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>{t("stripe.step8")}</StepLabel>
								<StepContent>
									<ul style={{ fontSize: "12px" }}>
										{t("stripe.step8Bis")
											.split(",")
											.map((s) => (
												<li>{s}</li>
											))}
									</ul>
									<img style={{ maxWidth: "100%" }} src={Step2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>{t("stripe.step10")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step3} alt="step3" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
				<Modal
					open={showStripeWebhookModal}
					onClose={() => {
						setShowStripeWebhookModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							Stripe configuration
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={0} active={true}>
								<StepLabel>
									{t("stripe.step1")}{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									{t("stripe.step2")}
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									{t("stripe.step3")}{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step4")}
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									{t("stripe.step5")}{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										{t("stripe.step6")}
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>{t("stripe.step7W")}</StepLabel>
								<StepContent>
									<ul>
										<li>
											<b>{t("stripe.step7W1")}</b> {t("stripe.step7W11")}
										</li>
										<li>
											<b>{t("stripe.step7W2")}</b> {t("stripe.step7W21")}
										</li>
										<li>
											<b>{t("stripe.step7W3")}</b> {t("stripe.step7W31")}
										</li>
										<li>
											<b>{t("stripe.step7W4")}</b> {t("stripe.step7W41")}
										</li>
									</ul>
									<img style={{ maxWidth: "100%" }} src={Step10} alt="step10" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>{t("stripe.step8W")}</StepLabel>
							</Step>
							<Step key={5} active={true}>
								<StepLabel>{t("stripe.step9W")}</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step11} alt="step11" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
				<Modal
					disableEscapeKeyDown
					onBackdropClick={() => {}}
					open={showWelcomeModal}
					onClose={(event, reason) => {
						if (reason && reason === "backdropClick") {
							return;
						}
						setShowWelcomeModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: "calc(100% - 40px)",
							maxWidth: 600,
							bgcolor: "background.paper",
							boxShadow: 24,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
							display: "flex",
							flexDirection: "column",
							alignContent: "center",
							borderRadius: 2,
							"&:focus-visible": {
								outline: "none!important",
							},
						}}
					>
						<img
							src={WelcomeImage}
							alt="welcome image"
							style={{ width: "100%" }}
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignContent: "center",
								alignItems: "center",
								p: 3,
								gap: 1,
							}}
						>
							<Typography
								sx={{ textAlign: "center" }}
								variant="h3"
								component="h2"
							>
								{t("onboarding.welcomeTitle")}
							</Typography>
							<Typography
								sx={{ textAlign: "center" }}
								variant="body1"
								component="p"
							>
								{t("onboarding.welcomeSubtitle")}
							</Typography>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									width: "200px",
									marginTop: 4,
									gap: 2,
								}}
							>
								<Button
									variant="text"
									onClick={async () => {
										setShowWelcomeModal(false);
										try {
											await axios.post(
												ADMIN_URL + "adminUpdateOnboarding",
												{},
												{
													headers: {
														authorization: localStorage.getItem("token"),
													},
												}
											);
											await getUser();
										} catch (error) {
											console.log(error);
										}
									}}
								>
									{t("onboarding.skip")}
								</Button>
								<Button
									variant="contained"
									onClick={() => {
										setShowWelcomeModal(false);
										setRun(true);
										setOnboardingStarted(true);
									}}
								>
									{t("onboarding.letsDoIt")}
								</Button>
							</Box>
						</Box>
					</Box>
				</Modal>
				<Modal
					disableEscapeKeyDown
					onBackdropClick={() => {}}
					open={showWelcomeModalMobile}
					onClose={(event, reason) => {
						if (reason && reason === "backdropClick") {
							return;
						}
						setShowWelcomeModalMobile(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: "calc(100% - 40px)",
							maxWidth: 600,
							bgcolor: "background.paper",
							boxShadow: 24,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
							display: "flex",
							flexDirection: "column",
							alignContent: "center",
							borderRadius: 2,
							"&:focus-visible": {
								outline: "none!important",
							},
						}}
					>
						<img
							src={WelcomeImage}
							alt="welcome image"
							style={{ width: "100%" }}
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignContent: "center",
								alignItems: "center",
								p: 3,
								gap: 1,
							}}
						>
							<Typography
								sx={{ textAlign: "center" }}
								variant="h3"
								component="h2"
							>
								{t("onboarding.welcomeTitle")}
							</Typography>
							<ul style={{ paddingLeft: "20px" }}>
								<li>
									<Typography
										sx={{ textAlign: "left", marginBottom: 1 }}
										variant="body1"
										component="p"
									>
										{t("onboarding.welcomeSubtitleMobile1")}
									</Typography>
								</li>
								<li>
									<Typography
										sx={{ textAlign: "left", marginBottom: 1 }}
										variant="body1"
										component="p"
									>
										{t("onboarding.welcomeSubtitleMobile2")}
									</Typography>
								</li>
								<li>
									<Typography
										sx={{ textAlign: "left", marginBottom: 1 }}
										variant="body1"
										component="p"
									>
										{t("onboarding.welcomeSubtitleMobile3")}
									</Typography>
								</li>
								<li>
									<Typography
										sx={{ textAlign: "left", marginBottom: 1 }}
										variant="body1"
										component="p"
									>
										{t("onboarding.welcomeSubtitleMobile4")}
									</Typography>
								</li>
							</ul>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									width: "200px",
									marginTop: 4,
									gap: 2,
								}}
							>
								<Button
									variant="contained"
									onClick={async () => {
										setShowWelcomeModalMobile(false);
										try {
											await axios.post(
												ADMIN_URL + "adminUpdateOnboarding",
												{},
												{
													headers: {
														authorization: localStorage.getItem("token"),
													},
												}
											);
											await getUser();
										} catch (error) {
											console.log(error);
										}
									}}
								>
									{t("onboarding.letsDoIt")}
								</Button>
							</Box>
						</Box>
					</Box>
				</Modal>
				<Modal
					disableEscapeKeyDown
					open={onboardingFinished}
					onClose={(event, reason) => {
						if (reason && reason === "backdropClick") {
							return;
						}
						setOnboardingFinished(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: "calc(100% - 40px)",
							maxWidth: 600,
							bgcolor: "background.paper",
							boxShadow: 24,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
							display: "flex",
							flexDirection: "column",
							alignContent: "center",
							borderRadius: 2,
							"&:focus-visible": {
								outline: "none!important",
							},
						}}
					>
						<img
							src={OnboardingFinishedImage}
							alt="onboarding finished image"
							style={{ width: "100%" }}
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignContent: "center",
								alignItems: "center",
								p: 3,
								gap: 1,
							}}
						>
							<Typography
								sx={{ textAlign: "center" }}
								variant="h3"
								component="h2"
							>
								{t("onboarding.finishedTitle")}
							</Typography>
							<Typography
								sx={{ textAlign: "center" }}
								variant="body1"
								component="p"
							>
								{t("onboarding.finishedSubtitle")}
							</Typography>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									marginTop: 4,
									width: "100%",
								}}
							>
								<Button
									sx={{ width: "250px" }}
									variant="contained"
									onClick={async () => {
										setOnboardingFinished(false);
									}}
								>
									{t("onboarding.great")}
								</Button>
							</Box>
						</Box>
					</Box>
				</Modal>
			</div>
		</>
	);
}
